import { useState } from "react";
import styled, { css } from "styled-components";

import {
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  Grid,
  Stack,
  Box,
  FormHelperText,
} from "@mui/material";
import Dialog from "src/components/core/Dialog";
import Button from "src/components/core/Button";
import LabelSection from "src/components/core/LabelSection";
import TextField from "src/components/core/TextField";
import MetaTagComponent from "src/modules/exclusive-deal/MataTagComponent";

import CloseIcon from "@mui/icons-material/Close";
import ImageIcon from "src/components/icon/Image";

import font from "src/styles/font";
import { DarkGrey, Grey, White01 } from "src/styles/color";
import { useDialog } from "src/context/DialogContext";
import { useSnackbar } from "notistack";

import { addDealGroup, updateDealGroup } from "src/api/deal";

const BoxWrapper = styled.div`
  width: 100%;
  height: auto;
  padding: 32px;
  border-radius: 32px;
  background-color: #ffffff;
  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.1);
  // display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 32px;

  :last-child {
    margin-bottom: 0;
  }
`;

const WrapperTextfield = styled.div`
  width: 100%;

  .TextField-without-border-radius fieldset {
    border-radius: 16px;
    // text-align: center;
    // background: #fff;
  }
  .TextField-without-border-radius-amount fieldset {
    border-radius: 16px;
    width: 100%;
    text-align: center;
    background: #fff;
  }
  .MuiAutocomplete-root {
    margin: 0;
  }
  .MuiOutlinedInput-input {
    background: #fff;
    /* border-radius: 16px; */
    padding: 16px;
  }
  .MuiInputBase-root-MuiOutlinedInput-root {
    border-radius: 16px;
    background: #fff;
  }
  .MuiInputBase-root-MuiOutlinedInput-root-MuiSelect-root {
    border-radius: 16px;
  }

  .MuiTextField-root {
    border-radius: 16px;
  }
  .MuiOutlinedInput-root {
    border-radius: 16px;
  }
  .MuiInputAdornment-root {
    font-size: ${font.size.sm};
    color: ${Grey};
  }
`;

const S = {};

S.WrapperUploadSection = styled.div`
  width: 100%;
  max-width: 450px;
  margin: 0 auto;
`;

S.UploadTitle = styled.div`
  font-size: ${font.size.xs};
  font-weight: 400;
  color: ${DarkGrey};
  margin-bottom: 8px;
`;

S.PreviewImageUploadBanner = styled.div`
  position: relative;
  width: 100%;
  max-width: 100%;
  padding-top: calc(100% / (1440 / 540));
  background-color: #f3f1f2;
  border-radius: 16px;
  /* grid-column: span 7; */
`;

S.WrapperPreviewImageUpload = styled.div`
  width: 100%;
  height: max-content;
  /* max-height: 300px; */
  display: flex;
  align-items: center;
  justify-content: center;
`;

S.PreviewImageUploadBox = styled.div`
  position: relative;
  max-width: 100%;
  /* padding-top: 100%; */
  padding-top: calc(100% / (256 / 256));
  background-color: ${White01};
  border-radius: 16px;
  /* grid-column: span 7; */

  ${({ type }) =>
    type === "hover-img"
      ? css`
          /* padding-top: calc(100% / (1440 / 798)); */
          aspect-ratio: 147 / 192;
        `
      : css`
          /* padding-top: 200px; */
          width: 100%;
        `}
`;

S.UploadInnerBox = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

S.UploadInput = styled.label`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
`;

S.UploadLabel = styled.span`
  font-size: ${font.size.sm};
  font-weight: 500;
  color: ${DarkGrey};
  margin-top: 8px;

  &::after {
    content: "*";
    font-weight: 600;
    color: #e04132;
  }
`;

S.UploadHelperText = styled.span`
  display: flex;
  justify-content: center;
  font-size: ${font.size.sm};
  color: ${DarkGrey};
  text-align: center;
  white-space: pre-line;
  margin-top: 8px;
`;

S.UploadedPreviewImage = styled.img`
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  border-radius: 15px;
  object-fit: cover;
`;

const AddGroupDialog = ({ initialValue, onClose, onSuccess, editable }) => {
  const { enqueueSnackbar } = useSnackbar();
  const { openDialog } = useDialog();

  const [formData, setFormData] = useState(
    initialValue ?? {
      _id: null,
      name: "",
      icon: null,
      icon_hover: null,
      banner: null,
      position: null,
      meta_tag: {
        title: "",
        desc: "",
        img: null,
        // link: "",
        keywords: "",
      },
      product_choice_deals: [],
    }
  );

  const isFormValid = ["name", "icon", "icon_hover", "banner"].every(
    (required) => {
      let objVal = formData[required];
      return objVal !== null && objVal !== "";
    }
  );

  const isMetaTagValid = Object.keys(formData?.meta_tag).every((required) => {
    let objVal = formData?.meta_tag[required];
    return objVal !== null && objVal !== "";
  });

  const handleOnClose = () => {
    openDialog({
      type: "confirm",
      title: `คุณต้องการออกจากหน้านี้ใช่หรือไม่`,
      onConfirm: () => {
        onClose();
      },
      maxWidth: 342,
    });
  };

  const handleSubmit = async () => {
    try {
      const { _id, meta_tag, ...prevData } = formData;
      const payload = {
        ...prevData,
        ...(_id !== null ? { _id: _id } : {}),
        meta_tag: {
          title: meta_tag.title,
          desc: meta_tag.desc,
          keywords: meta_tag.keywords,
        },
        img: meta_tag.img,
      };

      // ??
      const data = new FormData();

      for (const field in payload) {
        if (field === "meta_tag" || field === "product_choice_deals") {
          data.append(field, JSON.stringify(payload[field]));
        } else {
          data.append(field, payload[field]);
        }
      }

      !editable ? await addDealGroup(data) : await updateDealGroup(data);

      enqueueSnackbar(`${editable ? "บันทึก" : "เพิ่มห้อง"}สำเร็จ`, {
        variant: "success",
      });

      onSuccess();
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <Dialog
      onClose={handleOnClose}
      aria-labelledby="customized-dialog-title"
      open={true}
      sx={{
        "& .MuiDialog-container": {
          "& .MuiPaper-root": {
            width: 1024,
            maxWidth: "100%",
          },
        },
        "& .MuiDialogContent-root": {
          pt: 1,
          pb: 4,
        },
      }}
    >
      <DialogTitle sx={{ p: 3, textAlign: "center" }}>
        {editable ? "แก้ไข" : "เพิ่ม"}หมวดหมู่
        <IconButton
          aria-label="close"
          onClick={handleOnClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent dividers>
        <BoxWrapper>
          <LabelSection
            style={{ marginBottom: 0 }}
            title="หมวดหมู่"
            headerStyle={{ marginBottom: "24px" }}
          >
            <WrapperTextfield>
              <TextField
                label="ชื่อหมวดหมู่"
                variant="outlined"
                required
                value={formData?.name}
                onChange={(e) =>
                  setFormData({ ...formData, name: e.target.value })
                }
                fullWidth
                inputProps={{ maxLength: 50 }}
                helperText={
                  !formData?.name ? (
                    "กรุณากรอกชื่อหมวดหมู่"
                  ) : (
                    <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
                      {formData?.name?.length}/50
                    </Box>
                  )
                }
                error={!formData?.name}
              />
            </WrapperTextfield>
          </LabelSection>
        </BoxWrapper>

        <BoxWrapper>
          <LabelSection
            style={{ marginBottom: 0 }}
            title="รูปภาพ"
            headerStyle={{ marginBottom: "24px" }}
          >
            <Grid
              container
              sx={{
                maxWidth: 470,
                mx: "auto",
                rowGap: 4,
                justifyContent: "space-between",
              }}
            >
              <Grid item xs={12} sx={{ px: 3 }}>
                <S.UploadTitle>รูปแบนเนอร์ 1440x540 px</S.UploadTitle>
                <S.WrapperPreviewImageUpload>
                  <S.PreviewImageUploadBanner>
                    {!formData?.banner ? (
                      <S.UploadInnerBox>
                        <Stack flexDirection={"row"}>
                          <input
                            id="previewBannerHandle"
                            type="file"
                            accept=".jpg,.jpeg,.png"
                            style={{ display: "none" }}
                            onChange={(e) => {
                              e.preventDefault();
                              setFormData({
                                ...formData,
                                banner: e.target.files[0],
                              });
                            }}
                            onClick={(e) => (e.currentTarget.value = null)}
                          />
                          <S.UploadInput htmlFor="previewBannerHandle">
                            <ImageIcon size={24} color="#6C6C70" />
                            <S.UploadLabel>อัปโหลดรูปภาพ</S.UploadLabel>
                            <S.UploadHelperText>
                              รูปภาพขนาด 1440x540 px ขนาดไฟล์สูงสุดไม่เกิน 4 MB
                            </S.UploadHelperText>
                          </S.UploadInput>
                        </Stack>
                      </S.UploadInnerBox>
                    ) : (
                      <>
                        <S.UploadedPreviewImage
                          src={
                            typeof formData?.banner === "string"
                              ? formData?.banner
                              : URL.createObjectURL(formData?.banner)
                          }
                          alt=""
                        />
                        <Stack
                          sx={{
                            position: "absolute",
                            top: 6,
                            right: 6,
                          }}
                          flexDirection={"row"}
                          columnGap={1}
                        >
                          <IconButton
                            sx={{
                              padding: "4px",
                              backgroundColor: "#BCBCC0bd",
                            }}
                            onClick={() => {
                              setFormData({
                                ...formData,
                                banner: null,
                              });
                            }}
                          >
                            <CloseIcon sx={{ color: "#ffffff" }} />
                          </IconButton>
                        </Stack>
                      </>
                    )}
                  </S.PreviewImageUploadBanner>
                </S.WrapperPreviewImageUpload>
                {!formData?.banner && (
                  <FormHelperText error={!formData?.banner}>
                    กรุณาเลือกรูปแบนเนอร์
                  </FormHelperText>
                )}
              </Grid>

              <Grid item xs={5.5}>
                <S.UploadTitle>รูปหน้าปก 256x256 px</S.UploadTitle>
                <S.WrapperPreviewImageUpload>
                  <S.PreviewImageUploadBox type="cover-img">
                    {!formData?.icon ? (
                      <S.UploadInnerBox>
                        <Stack flexDirection={"row"}>
                          <input
                            id="previewGroupIconHandle"
                            type="file"
                            accept=".jpg,.jpeg,.png"
                            style={{ display: "none" }}
                            onChange={(e) => {
                              e.preventDefault();
                              setFormData({
                                ...formData,
                                icon: e.target.files[0],
                              });
                            }}
                            onClick={(e) => (e.currentTarget.value = null)}
                          />
                          <S.UploadInput htmlFor="previewGroupIconHandle">
                            <ImageIcon size={24} color="#6C6C70" />
                            <S.UploadLabel>อัปโหลดรูปภาพ</S.UploadLabel>
                            <S.UploadHelperText>
                              {`รูปภาพขนาด 256x256 px\nขนาดไฟล์สูงสุดไม่เกิน 4 MB`}
                            </S.UploadHelperText>
                          </S.UploadInput>
                        </Stack>
                      </S.UploadInnerBox>
                    ) : (
                      <>
                        <S.UploadedPreviewImage
                          src={
                            typeof formData?.icon === "string"
                              ? formData?.icon
                              : URL.createObjectURL(formData?.icon)
                          }
                          alt=""
                        />
                        <Stack
                          sx={{
                            position: "absolute",
                            top: 6,
                            right: 6,
                          }}
                          flexDirection={"row"}
                          columnGap={1}
                        >
                          <IconButton
                            sx={{
                              padding: "4px",
                              backgroundColor: "#BCBCC0bd",
                            }}
                            onClick={() => {
                              setFormData({
                                ...formData,
                                icon: null,
                              });
                            }}
                          >
                            <CloseIcon sx={{ color: "#ffffff" }} />
                          </IconButton>
                        </Stack>
                      </>
                    )}
                  </S.PreviewImageUploadBox>
                </S.WrapperPreviewImageUpload>
                {!formData?.icon && (
                  <FormHelperText error={!formData?.icon}>
                    กรุณาเลือกรูปหน้าปก
                  </FormHelperText>
                )}
              </Grid>

              <Grid item xs={5.5}>
                <S.UploadTitle>รูปโฮเวอร์ 147x192 px</S.UploadTitle>
                <S.WrapperPreviewImageUpload>
                  <S.PreviewImageUploadBox type="hover-img">
                    {!formData?.icon_hover ? (
                      <S.UploadInnerBox>
                        <Stack flexDirection={"row"}>
                          <input
                            id="previewGroupHoverIconHandle"
                            type="file"
                            accept=".jpg,.jpeg,.png"
                            style={{ display: "none" }}
                            onChange={(e) => {
                              e.preventDefault();
                              setFormData({
                                ...formData,
                                icon_hover: e.target.files[0],
                              });
                            }}
                            onClick={(e) => (e.currentTarget.value = null)}
                          />
                          <S.UploadInput htmlFor="previewGroupHoverIconHandle">
                            <ImageIcon size={24} color="#6C6C70" />
                            <S.UploadLabel>อัปโหลดรูปภาพ</S.UploadLabel>
                            <S.UploadHelperText>
                              {`รูปภาพขนาด 147x192 px\nขนาดไฟล์สูงสุดไม่เกิน 4 MB`}
                            </S.UploadHelperText>
                          </S.UploadInput>
                        </Stack>
                      </S.UploadInnerBox>
                    ) : (
                      <>
                        <S.UploadedPreviewImage
                          src={
                            typeof formData?.icon_hover === "string"
                              ? formData?.icon_hover
                              : URL.createObjectURL(formData?.icon_hover)
                          }
                          alt=""
                        />
                        <Stack
                          sx={{
                            position: "absolute",
                            top: 6,
                            right: 6,
                          }}
                          flexDirection={"row"}
                          columnGap={1}
                        >
                          <IconButton
                            sx={{
                              padding: "4px",
                              backgroundColor: "#BCBCC0bd",
                            }}
                            onClick={() => {
                              setFormData({
                                ...formData,
                                icon_hover: null,
                              });
                            }}
                          >
                            <CloseIcon sx={{ color: "#ffffff" }} />
                          </IconButton>
                        </Stack>
                      </>
                    )}
                  </S.PreviewImageUploadBox>
                </S.WrapperPreviewImageUpload>
                {!formData?.icon_hover && (
                  <FormHelperText error={!formData?.icon_hover}>
                    กรุณาเลือกรูปโฮเวอร์
                  </FormHelperText>
                )}
              </Grid>
            </Grid>
          </LabelSection>
        </BoxWrapper>

        <BoxWrapper>
          <LabelSection
            style={{ marginBottom: 0 }}
            title="Metatag"
            headerStyle={{ marginBottom: "24px" }}
          >
            <MetaTagComponent
              keyImg="groupMetaTagFieldHandle"
              metatagData={formData?.meta_tag}
              setMetatagData={(val) =>
                setFormData({
                  ...formData,
                  meta_tag: val,
                })
              }
              isEdit={true}
            />
          </LabelSection>
        </BoxWrapper>
      </DialogContent>

      <DialogActions
        sx={{
          justifyContent: "center",
        }}
      >
        <Button
          variant="outlined"
          size="large"
          onClick={handleOnClose}
          sx={{
            minWidth: 160,
          }}
        >
          ยกเลิก
        </Button>
        <Button
          variant="contained"
          size="large"
          onClick={() => {
            openDialog({
              type: "confirm",
              title: editable
                ? `คุณต้องการยืนยันการแก้ไขใช่หรือไม่`
                : `คุณต้องการเพิ่มหมวดหมู่ใช่หรือไม่?`,
              onConfirm: () => {
                handleSubmit();
              },
              maxWidth: 342,
            });
          }}
          sx={{
            minWidth: 160,
          }}
          // autoFocus // enable auto focus to increase accessibility
          disabled={!isFormValid || !isMetaTagValid}
        >
          {editable ? "ยืนยัน" : "เพิ่ม"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AddGroupDialog;
